function safeParse(key, defaultValue = null) {
  try {
    const val = localStorage.getItem(key);
    if (val === null) return defaultValue;
    return JSON.parse(val);
  } catch (e) {
    console.warn(`Failed to parse localStorage key "${key}"`, e);
    return defaultValue;
  }
}

export default safeParse;
